<template>
  <v-row>
    <v-col>
      <v-combobox
        :loading="$apollo.loading"
        :items="forecastsItems"
        outlined
        :disabled="disabled"
        :placeholder="disabled ? '' : 'Skriv kommentar...'"
        v-model="forecast_comment"
        @input="v => checkEmpty('forecast_comment', v)"
        :append-icon="isDiff ? 'mdi-alert-octagram' : ''"
        label="Kommentar"
      ></v-combobox>
    </v-col>
  </v-row>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { required } from '@/common/validationRules'

export default {
  name: 'TrafficMessageForecastField',

  props: {
    disabled: Boolean,
    isDiff: Boolean,
    checkEmpty: Function
  },

  data: () => ({
    required
  }),

  computed: {
    forecast_comment: sync('trafficMessage/model@forecast_comment'),

    forecastsItems() {
      return (this.forecasts || []).map(x => x.name)
    }
  },

  apollo: {
    forecasts: {
      query: gql`
        query forecasts {
          forecasts {
            uuid
            name
          }
        }
      `
    }
  }
}
</script>
